import React, { useEffect, useState } from "react";
import { Step1 } from "./Step1";
import { Step2 } from "./Step2";
import { Step3 } from "./Step3";
import { Step4 } from "./Step4";
import { Step5 } from "./Step5";
import { useDispatch } from "react-redux";
import { requestAuth } from "../../../http/httpRequest";
import { toastOn } from "../../../store/slices/toast";
import { Step6 } from "./Step6";
import { Step7 } from "./Step7";

export const StepCompraViews = ({ data, setReload, stepsPermissions }) => {
  const dispatch = useDispatch();
  const [detail, setDetail] = useState(null);
  const [mainRecall, setMainRecall] = useState(false);
  const [currentNav, setCurrentNav] = useState(data.paso);
  const [isPasoSalteado, setIsPasoSalteado] = useState(false);
  const getData = async () => {
    await requestAuth("get", `compra/${data.id}/detail`, null)
      .then((response) => {
        setDetail(response.data);

        const paso = response.data.paso;
        const solicitados = response.data.solicitadosMap || [];

        const isPasoEntre3y4 = paso === 3 || paso === 4;

        const esNoRetornable = (item) =>
          typeof item.etiqueta === "string" && item.etiqueta.includes("N/R");

        const soloNoRetornables =
          Array.isArray(solicitados) &&
          solicitados.length > 0 &&
          solicitados.every((p) => esNoRetornable(p));

        let newPaso = paso;
        if (isPasoEntre3y4 && soloNoRetornables) {
          newPaso = 5;
        }

        console.log("Paso backend:", paso);
        console.log("Nuevo paso (frontend):", newPaso);

        setIsPasoSalteado(newPaso === 5 && paso !== 5);
        setCurrentNav(newPaso);
      })
      .catch((error) => {
        dispatch(
          toastOn({
            type: "danger",
            message:
              error?.response?.data?.message || "Error al listar las opciones",
          })
        );
      });
  };


  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainRecall]);

  return (
    detail != null && (
      <>
        <div className="p-3 min-h-[550px]">
          {currentNav === 1 && stepsPermissions?.viewSteps?.includes(1) ? (
            <Step1
              generalData={detail}
              setMainRecall={setMainRecall}
              setReload={setReload}
              stepNumber={1}
              stepsPermissions={stepsPermissions}
            />
          ) : (
            currentNav === 1 &&
            !stepsPermissions?.viewSteps?.includes(1) && (
              <AlertCardSteps message={data?.nombre_paso} />
            )
          )}
          {currentNav === 2 && stepsPermissions?.viewSteps?.includes(2) ? (
            <Step2
              generalData={detail}
              setMainRecall={setMainRecall}
              setReload={setReload}
              stepNumber={2}
              saveUrlApi={`compra/${detail.id}/paso/2`}
              stepsPermissions={stepsPermissions}
            />
          ) : (
            currentNav === 2 &&
            !stepsPermissions?.viewSteps?.includes(2) && (
              <AlertCardSteps message={data?.nombre_paso} />
            )
          )}
          {currentNav === 3 && stepsPermissions?.viewSteps?.includes(3) ? (
            <Step3
              generalData={detail}
              setMainRecall={setMainRecall}
              setReload={setReload}
              stepNumber={3}
              saveUrlApi={`compra/${detail.id}/paso/3`}
              stepsPermissions={stepsPermissions}
            />
          ) : (
            currentNav === 3 &&
            !stepsPermissions?.viewSteps?.includes(3) && (
              <AlertCardSteps message={data?.nombre_paso} />
            )
          )}
          {currentNav === 4 && stepsPermissions?.viewSteps?.includes(4) ? (
            <Step4
              generalData={detail}
              setMainRecall={setMainRecall}
              setReload={setReload}
              stepNumber={4}
              saveUrlApi={`compra/${detail.id}/paso/4`}
              stepsPermissions={stepsPermissions}
            />
          ) : (
            currentNav === 4 &&
            !stepsPermissions?.viewSteps?.includes(4) && (
              <AlertCardSteps message={data?.nombre_paso} />
            )
          )}
          {currentNav === 5 && stepsPermissions?.viewSteps?.includes(5) ? (
            <Step5
              generalData={detail}
              setMainRecall={setMainRecall}
              setReload={setReload}
              stepNumber={5}
              isPasoSalteado={isPasoSalteado}
              saveUrlApi={`compra/${detail.id}/paso/5`}
              stepsPermissions={stepsPermissions}
            />
          ) : (
            currentNav === 5 &&
            !stepsPermissions?.viewSteps?.includes(5) && (
              <AlertCardSteps message={data?.nombre_paso} />
            )
          )}
          {currentNav === 6 && stepsPermissions?.viewSteps?.includes(6) ? (
            <Step6
              generalData={detail}
              setMainRecall={setMainRecall}
              setReload={setReload}
              stepNumber={6}
              saveUrlApi={`compra/${detail.id}/paso/6`}
              stepsPermissions={stepsPermissions}
            />
          ) : (
            currentNav === 6 &&
            !stepsPermissions?.viewSteps?.includes(6) && (
              <AlertCardSteps message={data?.nombre_paso} />
            )
          )}
          {
            currentNav === 7 && (
              <Step7
                generalData={detail}
                setMainRecall={setMainRecall}
                setReload={setReload}
                stepNumber={7}
                saveUrlApi={`compra/${detail.id}/paso/7`}
                stepsPermissions={stepsPermissions}
              />
            )
            // :
            // currentNav === 6 && !stepsPermissions?.viewSteps?.includes(6) &&
            // <AlertCardSteps
            //     message={data?.nombre_paso}
            // />
          }
        </div>
        <NavStepper
          detail={detail}
          setCurrentNav={setCurrentNav}
          currentNav={currentNav}
          isPasoSalteado={isPasoSalteado}
          stepsPermissions={stepsPermissions}
        />
      </>
    )
  );
};

const NavStepper = ({
  detail,
  setCurrentNav,
  currentNav,
  stepsPermissions,
  isPasoSalteado
}) => {
  return (
    <>
      <div className="col-span-12 flex justify-center gap-x-5 py-2 overflow-auto">
        {[...Array(6).keys()].map((i, index) => (
          <ButtonStep
            key={index}
            currentPaso={detail?.paso}
            paso={i + 1}
            setCurrentNav={setCurrentNav}
            currentNav={currentNav}
            viewSteps={stepsPermissions?.viewSteps}
          />
        ))}
      </div>
    </>
  );
};

const ButtonStep = ({
  paso,
  setCurrentNav,
  currentPaso,
  currentNav,
  viewSteps,
}) => {
  return viewSteps?.includes(paso) ? (
    <div className={``}>
      <button
        type="button"
        className={`rounded-full ${
          currentPaso > paso
            ? "bg-green-400 dark:bg-green-600 text-gray-50 dark:text-gray-50"
            : "bg-gray-100 text-gray-400 dark:bg-gray-500 dark:text-gray-600"
        } py-[4px] px-2 text-sm dark:hover:bg-gray-500 transition ease-linear`}
        onClick={() => {
          setCurrentNav(paso);
        }}
        disabled={viewSteps?.includes(paso) ? false : true}
      >
        <i className="fa-solid fa-check" />
      </button>
      <div
        className={`mt-2 ${
          currentNav === paso ? "bg-gray-400" : "bg-gray-200 dark:bg-gray-600"
        } h-1 rounded-lg`}
      />
    </div>
  ) : (
    <div className={``}>
      <button
        type="button"
        className={`rounded-full ${
          currentPaso > paso
            ? "bg-red-400 dark:bg-red-600 text-gray-50 dark:text-gray-50"
            : "bg-gray-100 text-gray-400 dark:bg-gray-500 dark:text-gray-600"
        } py-[4px] px-2 text-sm dark:hover:bg-gray-500 transition ease-linear`}
        // onClick={() => {
        //     setCurrentNav(paso)
        // }}
        // disabled={viewSteps?.includes(paso) ? false : true}
      >
        <i className="fa-solid fa-lock" />
      </button>
      <div
        className={`mt-2 ${
          currentNav === paso ? "bg-gray-400" : "bg-gray-200 dark:bg-gray-600"
        } h-1 rounded-lg`}
      />
    </div>
  );
};

const AlertCardSteps = ({ message }) => {
  return (
    <div className={`text-gray-800 dark:text-gray-200`}>
      Pendiente en <span className="font-semibold">{message}</span>!
    </div>
  );
};
